export default __webpack_public_path__ + "static/19-0f416f23a27eb192a85d898da3cf9a70.png";